const levels = [];
const optionsRange = [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
const levelsRange = [5];

optionsRange.forEach(options => {
  levels.push({
    id: `T${options}`,
    max_number: options,
    options,
    nextLevel: options + 1,
    range: 100
  });
});

// optionsRange.forEach(options => {
//   levelsRange.forEach(lvl => {
//     levels.push({
//       id: `T${options}L${lvl}`,
//       max_number: options,
//       options,
//       // range: options * lvl,
//       range: 100

//     });
//   });
// });

export default levels;
